import React from 'react';
import {
  NodeType,
  getNodeTypeName,
} from '@/features/connect-dots/types/cytoscape';
import { NODE_STYLE_CONFIG } from '@/features/connect-dots/styles/networkStyles';
import { Toggle } from '@/components/Elements';
import { useTranslation } from 'react-i18next';

interface NetworkLegendProps {
  nodeCount?: number;
  nodeTypeFilters: { [key in NodeType]: boolean };
  updateNodeTypeFilter: (nodeType: NodeType, isVisible: boolean) => void;
}

const NetworkLegend: React.FC<NetworkLegendProps> = ({
  nodeCount = 0,
  nodeTypeFilters,
  updateNodeTypeFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className="rounded bg-white p-4 shadow-lg">
      <div className="flex flex-col space-y-2 text-sm">
        {/* ノードタイプフィルター - 各ノードタイプに対するトグルスイッチ */}
        <div className="">
          {Object.values(NodeType)
            .filter(
              (nodeType) =>
                nodeType === NodeType.CROSS ||
                nodeType === NodeType.CROSS_ISSUE ||
                nodeType === NodeType.NORMAL ||
                nodeType === NodeType.SOCIAL_ISSUE
            )
            .map((nodeType) => (
              <div key={nodeType} className="mb-2">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div
                      className="mr-2 inline-block size-3 rounded-full"
                      style={{
                        backgroundColor:
                          NODE_STYLE_CONFIG[nodeType]['background-color'],
                      }}
                    ></div>
                    <label className="mr-2 text-sm font-medium">
                      {t(getNodeTypeName(nodeType))}
                    </label>
                  </div>
                  <Toggle
                    checked={nodeTypeFilters[nodeType] !== false}
                    onChange={(checked) =>
                      updateNodeTypeFilter(nodeType, checked)
                    }
                    size="sm"
                    label={
                      nodeTypeFilters[nodeType] !== false
                        ? t('表示')
                        : t('非表示')
                    }
                    aria-label={`Toggle visibility of ${nodeType} nodes`}
                  />
                </div>
              </div>
            ))}
        </div>

        <div className="mt-2 border-t pt-2 text-xs text-gray-500">
          <p className="text-right">
            {t('総数')}：{nodeCount}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NetworkLegend;
